import { render, staticRenderFns } from "./user-multi-edit-dialog.vue?vue&type=template&id=4b80693e&scoped=true"
import script from "./user-multi-edit-dialog.vue?vue&type=script&lang=js"
export * from "./user-multi-edit-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b80693e",
  null
  
)

export default component.exports